import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
// import Spinner from 'react-bootstrap/Spinner';
import nonotification from './gallary/no-msg.png'
import Spinner from 'react-bootstrap/Spinner';

export function Notification({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER; // http://seller.localhost:5000
    const [prods, setProds] = useState();
    const navigate = useNavigate();
    let S3_URL = process.env.REACT_APP_S3_URL;

    let jToken = localStorage.getItem('token');

    // Spinner Show enabling
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/returnReq`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: 'include'
                })
                const res = await response.json();
                if (response.status === 500) {
                    throw new Error('Error while fetching notifications');
                } else {

                    if (response.status === 200) {
                        setProds(res.db_res);
                    } else {
                        navigate('/login');
                    }
                }
                if (res.role === 'designer'){
                    navigate('/unauthorized');
                }
            } catch (error) {
                // await loginStatus();
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData();
    }, [jToken, loginStatus, apiURL, navigate]);

    async function acceptOrder(retId, decision) {
        try {
            setShowSpinner(true);
            const response = await fetch(`${apiURL}/decision`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'decision': decision,
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({ id: retId }),
                credentials: 'include'
            })
            if (response.status === 500) {
                throw new Error('Error while considering order');
            } else {
                if (response.status === 200) {
                    alert('Decision has been saved!');
                    setShowSpinner(false);
                    window.location.reload();
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            await loginStatus();
            navigate('/login');
            console.log(error.message);
        }
    }

    return (
        <>
            {
                !prods ? (
                    <div className={`${styles.spinnerDiv}`}>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : showSpinner ? (
                    <div className={`${styles.waitingSpinnerDiv}`}>
                        <Spinner animation="grow" style={{ width: "100px", height: "100px" }} />
                    </div>
                ) :
                    prods.length === 0 ? (
                        <>
                            <div className={`${styles.noNotificationDiv}`}>
                                <span className={`${styles.noNotificationSpan}`}>It seems there is no pending notification</span>
                                <img src={nonotification} alt="no notificationi" style={{ height: '60px' }} />
                            </div>
                        </>) : (
                        <>
                            <div className={`${styles.sellernotificationMain}`}>
                                {prods.map((item) => {
                                    return (
                                        <>
                                            <div className={`${styles.sellerNotificationDiv}`}>
                                                <div className={`${styles.sellerNotificationSubDiv}`}>
                                                    <div className={`${styles.sellernotificationImageDiv}`}>
                                                        <img src={`${S3_URL}/${item.photo1}`} alt="productimage" className={`${styles.sellerNotificationImage}`}></img>
                                                    </div>
                                                    <div className={`${styles.notificationPNnameDiv}`}>
                                                        <span>{item.name}</span>
                                                        <span>Price: {item.currentprice}</span>
                                                    </div>
                                                    <div className={`${styles.notificationinfoDiv}`}>
                                                        <div className={`${styles.notificationName}`}>
                                                            <span>{item.fname}</span>
                                                            <span>{item.lname}</span>
                                                        </div>
                                                        <div className={`${styles.notificationAddress}`}>
                                                            <span>{item.houseNo}</span>
                                                            <span>{item.roadName}</span>
                                                            <span>{item.areaName}</span>
                                                            <span>{item.city}</span>
                                                            <span>{item.pin}</span>
                                                            <span>{item.phoneNo}</span>
                                                            <span>{item.altPhoneNo}</span>
                                                            <span>Purchased on: {new Date(item.purchaseTime).getDate()}/{new Date(item.purchaseTime).getMonth() + 1}/{new Date(item.purchaseTime).getFullYear()}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`${styles.selletNotifiationAcceptDiv}`}>
                                                    <button className={`${styles.sellerNotificationAccept}`} onClick={() => acceptOrder(item.retId, 'accept')}>Accept</button>
                                                    <button className={`${styles.sellerNotificationAccept}`} onClick={() => acceptOrder(item.retId, 'reject')}>Reject</button>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                            </div>
                        </>
                    )
            }
        </>
    )
}